import { useEffect, useState } from "react";
import axios from "axios";
import { Highlighter, Loader2, Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

const API = "/api";

const HighlightPage = () => {
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const authHeaders = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem("ecomdemo_token")}` },
  });

  useEffect(() => {
    axios.get(`${API}/admin/highlight`, authHeaders())
      .then((response) => setText(response.data.text || ""))
      .catch(() => toast.error("Failed to load highlight"))
      .finally(() => setLoading(false));
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSaving(true);
    try {
      const response = await axios.put(`${API}/admin/highlight`, { text }, authHeaders());
      setText(response.data.text || "");
      toast.success("Highlight updated successfully");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to update highlight");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="highlight-page">
      <div className="mb-8">
        <h1 className="flex items-center gap-3 text-2xl md:text-3xl font-bold text-gray-900">
          <Highlighter className="text-[#6C42F5]" size={28} /> Highlight
        </h1>
        <p className="mt-1 text-gray-600">Manage the highlight text shown in the app home API.</p>
      </div>

      <form onSubmit={handleSubmit} className="max-w-2xl rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
        <Label htmlFor="highlight-text" className="font-medium text-gray-700">Highlight text</Label>
        <Input
          id="highlight-text"
          value={text}
          onChange={(event) => setText(event.target.value)}
          disabled={loading}
          placeholder="Enter highlight text"
          className="mt-2 bg-white border-gray-300"
          data-testid="input-highlight"
        />
        <Button
          type="submit"
          disabled={loading || saving}
          className="mt-5 bg-[#6C42F5] text-white hover:bg-[#8C6CFF]"
        >
          {saving ? <Loader2 size={17} className="mr-2 animate-spin" /> : <Save size={17} className="mr-2" />}
          Save Highlight
        </Button>
      </form>
    </div>
  );
};

export default HighlightPage;
